export default __webpack_public_path__ + "static/media/AILA.56af832d.svg";